import "./intro.css";
import { useState, useEffect } from "react";

import Navbar from "../../components/parts/navbar/Navbar";
import TopLinks from "../../components/parts/TopLinks/TopLinks";
import Footer from "../../components/parts/footer/Footer";
import Menu from "../../components/parts/menu/Menu";
import BTNtoTop from "../../components/parts/BTNtoTop/BTNtoTop";
import VerificaToken from "../../components/utils/VerificaToken";
// 🔹 Debug wrapper
import Section from "../../components/debug/Section";

/* =========================
   INTRO PARTS
========================= */
import IntroBannerSlide from "./parts/IntroBanneSlide/IntroBanneSlide";
import IntroBanners from "./parts/IntroBanners/IntroBanners";
import IntroTitulos from "./parts/IntroTitulos/IntroTitulos";
import IntroProdutosDestaque from "./parts/IntroProdutosDestaque/IntroProdutosDestaque";
import IntroParceiros from "./parts/IntroParceiros/IntroParceiros";
import IntroBannerCategorias from "./parts/IntroBannersCategorias/IntroBannerCategorias ";
//import IntroDescricao from "./parts/IntroDescricao/IntroDescricao";
//import IntroBlogCards from "./parts/IntroBlogCards/IntroBlogCards";

function Intro() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [mostrarBlog, setMostrarBlog] = useState(false);

  // 🔹 Banners
  const [banners, setBanners] = useState([]);
  const [loadingBanners, setLoadingBanners] = useState(true);

  // 🔹 Títulos
  const [titulos, setTitulos] = useState([]);
  const [loadingTitulos, setLoadingTitulos] = useState(true);

  // 🔹 Produtos destaque
  const [produtosDestaque, setProdutosDestaque] = useState([]);
  const [loadingProdutosDestaque, setLoadingProdutosDestaque] = useState(true);

  // 🔹 Marcas
  const [marcas, setMarcas] = useState([]);
  const [loadingMarcas, setLoadingMarcas] = useState(true);

  // 🔹 Descricao
  const [descricao, setDescricao] = useState([]);
  const [loadingDescricao, setLoadingDescricao] = useState(true);

  /*
  async function fetchComDebug(url) {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    });

    const text = await response.text();

    console.group(`❌ Fetch erro em ${url}`);
    console.log("Status:", response.status);
    console.log("StatusText:", response.statusText);
    console.log("Headers:", [...response.headers.entries()]);
    console.log("Body bruto:", text);
    console.groupEnd();

    // tenta converter pra JSON
    try {
      return JSON.parse(text);
    } catch {
      throw new Error("Resposta não é JSON");
    }
  }
*/
  // 🔹 Carregar banners

    const carregarBanners = async () => {
      try {
        const response = await fetch(
          "https://app.eliandroalimentos.com.br/api/home_media/listar",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
          }
        );
        const data = await response.json();
        setBanners(data);
      } catch (error) {
        console.error("Erro ao buscar títulos:", error);
      } finally {
        setLoadingBanners(false);
      }
    }

    useEffect(() => {
  carregarBanners();
}, []);

    

  // 🔹 Carregar títulos
  const carregarTitulos = async () => {
    try {
      const response = await fetch(
        "https://app.eliandroalimentos.com.br/api/titulos/listar",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
        }
      );

      const data = await response.json();

      setTitulos(data);
    } catch (error) {
      console.error("Erro ao buscar títulos:", error);
    } finally {
      setLoadingTitulos(false);
    }
  };

  useEffect(() => {
    carregarTitulos();
  }, []);


  
     useEffect(() => {
    async function verificar() {
      const usuario = await VerificaToken();

      console.log(usuario);
    }

    verificar();
  }, []);


  
  // 🔹 Carregar produtos destaque
const carregarProdutosDestaque = async () => {
  try {
    const usuario = await VerificaToken();

    let body = {};

    if (usuario.login && usuario.tipo === "CNPJ") {
      body.codcliente = usuario.codcliente;
    }

    const response = await fetch(
      "https://app.eliandroalimentos.com.br/api/produtos_destaque/listarprodutosdestaquedesconto",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      }
    );

    const data = await response.json();

    setProdutosDestaque(data);
  } catch (error) {
    console.error("Erro ao buscar produtos:", error);
  } finally {
    setLoadingProdutosDestaque(false);
  }
};

useEffect(() => {
  carregarProdutosDestaque();
}, []);

useEffect(() => {
  carregarProdutosDestaque();
}, []);


  // 🔹 Carregar Marcas
  useEffect(() => {
    async function carregarMarcas() {
      try {
        const response = await fetch(
          "https://app.eliandroalimentos.com.br/api/marcas/listar",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
          }
        );
        const data = await response.json();
        setMarcas(data);
      } catch (error) {
        console.error("Erro ao buscar produtos:", error);
      } finally {
        setLoadingMarcas(false);
      }
    }

    carregarMarcas();
  }, []);

  // 🔹 Carregar Descricao
  useEffect(() => {
    async function carregarDescricao() {
      try {
        const response = await fetch(
          "https://app.eliandroalimentos.com.br/api/desc/listar",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
          }
        );
        const data = await response.json();
        setDescricao(data);
      } catch (error) {
        console.error("Erro ao buscar produtos:", error);
      } finally {
        setLoadingDescricao(false);
      }
    }

    carregarDescricao();
  }, []);


  /*
  <Section name="IntroBlogCards">
          <IntroBlogCards mostrarBlog={mostrarBlog} />
        </Section>

        <Section name="IntroDescrição">
          <IntroDescricao descricao={descricao} loading={loadingDescricao} />
        </Section>

        <Section name="IntroParceiros 2">
          <IntroParceiros
            marcas={marcas}
            setMarcas={setMarcas}
            loading={loadingMarcas}
            localizacao="introparceiros02"
          />
        </Section>
  */

  return (
    <>
      <Navbar />

      <TopLinks
        onOpenMenu={() => setMenuOpen(true)}
        mostrarBlog={mostrarBlog}
      />

      <Menu isOpen={menuOpen} onClose={() => setMenuOpen(false)} />

      <div className="intro-wrapper">
        <Section name="IntroBannerSlide">
          <IntroBannerSlide banners={banners} loading={loadingBanners} />
        </Section>

        <Section name="IntroTitulos 1">
          <IntroTitulos
            titulos={titulos}
            loading={loadingTitulos}
            localizacao="introtitulo"
            ordem={1}
            ordemsubtitulo={2}
            atualizarTitulos={carregarTitulos}
          />
        </Section>
        <Section name="IntroProdutosDestaque 1">
          <IntroProdutosDestaque
            produtosDestaque={produtosDestaque}
            loading={loadingProdutosDestaque}
            localizacao="1"
            atualizarProdutosDestaque={carregarProdutosDestaque}
          />
        </Section>
        <Section name="IntroTitulos 3">
          <IntroTitulos
            titulos={titulos}
            loading={loadingTitulos}
            localizacao="introtitulo"
            ordem={3}
          />
        </Section>

        <Section name="IntroParceiros 1">
          <IntroParceiros
            marcas={marcas}
            setMarcas={setMarcas}
            loading={loadingMarcas}
            localizacao="introparceiros01"
          />
        </Section>

        <Section name="IntroBanners 1">
          <IntroBanners //Banners componentes
            banners={banners}
            loading={loadingBanners}
            localizacao="introbanner"
            ordem={1}
            atualizarBanners={carregarBanners}
          />
        </Section>

        <Section name="IntroTitulos 4">
          <IntroTitulos
            titulos={titulos}
            loading={loadingTitulos}
            localizacao="introtitulo"
            ordem={4}
          />
        </Section>

        <Section name="IntroProdutosDestaque 2">
          <IntroProdutosDestaque
            produtosDestaque={produtosDestaque}
            loading={loadingProdutosDestaque}
            localizacao="2"
            atualizarProdutosDestaque={carregarProdutosDestaque}
          />
        </Section>

        <Section name="IntroBanner Minibanner1">
          <IntroBanners //Banners componentes
            banners={banners}
            loading={loadingBanners}
            localizacao="introminibanner"
            ordem={1}
            atualizarBanners={carregarBanners}
          />
        </Section>

        <Section name="IntroTitulos 5">
          <IntroTitulos
            titulos={titulos}
            loading={loadingTitulos}
            localizacao="introtitulo"
            ordem={5}
          />
        </Section>

        <Section name="IntroProdutosDestaque 3">
          <IntroProdutosDestaque
            produtosDestaque={produtosDestaque}
            loading={loadingProdutosDestaque}
            localizacao="3"
            atualizarProdutosDestaque={carregarProdutosDestaque}
          />
        </Section>

        <Section name="IntroBanners 3">
          <IntroBanners //Banners componentes
            banners={banners}
            loading={loadingBanners}
            localizacao="introbanner"
            ordem={3}
            atualizarBanners={carregarBanners}
          />
        </Section>

        

        <Section name="IntroBanners MiniBanner 2">
          <IntroBanners //Banners componentes
            banners={banners}
            loading={loadingBanners}
            localizacao="introminibanner"
            ordem={2}
            atualizarBanners={carregarBanners}
          />
        </Section>




        <Section name="IntroBannerCategorias">

          <IntroBannerCategorias 
          banners={banners} 
          loading={loadingBanners}
          atualizarBanners={carregarBanners}
          />
          
        </Section>

        
      </div>

      <BTNtoTop />

      <Footer mostrarBlog={mostrarBlog} />
    </>
  );
}

export default Intro;
